import {gsap} from 'gsap';

var slide1 = promokit.slide({
  el: '#slide-1',
  arrow: true,
  infinity: true,
  bullet: true,
});
var slide2 = promokit.slide({
  el: '#slide-2',
  arrow: true,
  infinity: true,
  bullet: true,
});

let subPageIndex = 1;
let subtabIndex = 1;
let firstch = true;
let subtabch = true;

const subtabAnimation = {
  'sub-1': gsap.timeline({paused: true})
      .addLabel('start')
      .staggerFrom(
          '.sub-1 dl',
          0.7, {y:50, opacity:0,ease: "power2.out"}, 0.1,'start+=.4'),

  'sub-2': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.sub-2 dl', {opacity: 0, y: '+=20', duration: .7})
};


const checkSubTab = ()=>{
  if ( subtabch ) { // 2페이지 첫 진입
    subtabch = false;
  }
}

const subPageAnimation = {
  'section-5-1': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-5-1__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .from('.section-5-1__con', {opacity: 0, y: '+=60', duration: .6}, 'start+=.8'),

  'section-5-2': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-5-2__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.4')
      .from('.section-5-2__con', {opacity: 0, y: '+=40', duration: .6, onComplete: checkSubTab()}, 'start+=.6'),

  'section-5-3': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-5-3__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .from('.section-5-3__con', {opacity: 0, y: '+=60', duration: .6}, 'start+=.8')
};

const bgAnimation = (index) =>{

  $('.section-5__bg').fadeOut();
  $('.section-5__bg').eq(index*1 -1).fadeIn();


    $('.section-5__chrct').fadeOut();

    switch( index ){
      case '1' :
        $('.section-5__chrct').eq(0).fadeIn();
        break;
      case '3':
        $('.section-5__chrct').eq(1).fadeIn();
        break;
    }

}

const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.section-5__menu', {opacity: 0, duration: 1}, 'start+=.6');

const mountAnimation2 = {
  'bg-1':gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-5__man', {opacity: 0, scale:3, x: '-=800', duration: .9,ease: "power4.out"}, 'start+=.4'),
  'bg-3':gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-5__woman', {opacity: 0, scale:3, x: '-=800', duration: .9,ease: "power4.out"}, 'start+=.4')
};




const SubPageRouter = (toPageIndex, delay = 0) => {
  let prevPageIndex = subPageIndex;

  $('.section-5__menu-item--active').removeClass('section-5__menu-item--active');
  $(`.section-5__menu-item--${toPageIndex}`).addClass('section-5__menu-item--active');
  $('.section-5__menu')
      .removeClass(`section-5__menu--active-1 
                    section-5__menu--active-2
                    section-5__menu--active-3
                    `)
      .addClass(`section-5__menu--active-${toPageIndex}`);

  $('.section-5__con--active').removeClass('section-5__con--active');
  $(`.section-5-${toPageIndex}`).addClass('section-5__con--active');

  if (prevPageIndex !== toPageIndex) {
    subPageAnimation[`section-5-${toPageIndex}`].restart();
    bgAnimation(toPageIndex);
  }
  else {
    setTimeout(() => {
      subPageAnimation[`section-5-${prevPageIndex}`].restart();
    }, 600);
  }

  subPageIndex = toPageIndex;
};


const SubtabRouter = (toTabIndex) => {

  let prevtabIndex = subtabIndex;

  $('.sub__menu-item--active').removeClass('sub__menu-item--active');
  $(`.sub__menu-item--${toTabIndex}`).addClass('sub__menu-item--active');
  $('.sub__menu')
      .removeClass(`sub__menu--active-1 
                    sub__menu--active-2`)
      .addClass(`sub__menu--active-${toTabIndex}`);


  $('.sub__con--active').removeClass('sub__con--active');
  $(`.sub-${toTabIndex}`).addClass('sub__con--active');

  if (prevtabIndex !== toTabIndex) {
    subtabAnimation[`sub-${toTabIndex}`].restart();
  }
  else {
    setTimeout(() => {
      subtabAnimation[`sub-${prevtabIndex}`].restart();
    }, 600);
  }


  subtabIndex = toTabIndex;
};



$(document).on('click', '.section-5__menu-item a', function(e){
  e.preventDefault();
  let index = $(this)[0].hash.replace(/(#s|s)ection-\d-/, '');

  if (subPageIndex == index) return;

  if ( index == 3 && firstch ) { // 3페이지 첫 진입
    $('.section-5__chrct').eq(2).fadeIn();
    mountAnimation2[`bg-${index}`].play();
    firstch = false;
  }

  if( index == 2){
    SubtabRouter(subtabIndex);
  }

  SubPageRouter(index);

});



$(document).on('click', '.sub__menu-item a', function(e){
  e.preventDefault();
  let index =  $(this)[0].hash.replace(/(#s|s)ub-/, '');
  if (subtabIndex == index) return;
  SubtabRouter(index);

});

export default {
  id: '#section-5',

  name: '주요 업데이트',

  enterStart() {
    mountAnimation.play();
    SubPageRouter(subPageIndex, 300);
    SubtabRouter(subtabIndex);

    if( subPageIndex != 2) {
      mountAnimation2[`bg-${subPageIndex}`].play();
    }
  },

  leaveEnd() {
    mountAnimation.seek(0).pause();
    subPageAnimation[`section-5-${subPageIndex}`].seek(0).pause();
  }
};



// WEBPACK FOOTER //
// ./src/js/pc/section-5.js